import { z } from 'zod';
import { toEmptyString } from './preprocess';

const isValidPhone = (value: string) => {
  const digits = value.replaceAll(/\D/g, '');
  return digits.length >= 10 && digits.length <= 11;
};

/** Telefone — sem preprocess (signUp, quiz). Preserva máscara. */
export const phoneField = z.string().refine(isValidPhone, 'Telefone inválido');

/** Telefone — opcional com preprocess (nationalUserSchema). Aceita vazio/undefined. Preserva máscara. */
export const phone = z.preprocess(
  toEmptyString,
  z.string().refine(val => val === '' || isValidPhone(val), 'Telefone inválido')
);
